import React from "react";
import { C } from "../../core/constants";
import { localizedPath } from "../../core/localePaths";
import { useI18n } from "../../features/i18n/LocaleProvider";

const linkStyle = (accent) => ({
  color: accent,
  textDecoration: "none",
});

export default function LegalFooterLinks({ acc }) {
  const { t, locale } = useI18n();
  return (
    <div style={{ textAlign: "center", padding: "14px 20px 28px", fontSize: 12, color: C.textMuted, lineHeight: 1.6 }}>
      <span style={{ color: C.textMuted }}>{t("footer_help_label")}:</span>{" "}
      <a href={localizedPath("contact", locale)} style={linkStyle(acc.primary)}>
        {t("contact_us")}
      </a>
      {" · "}
      <span style={{ color: C.textMuted }}>{t("legal")}:</span>{" "}
      <a href={localizedPath("terms", locale)} style={linkStyle(acc.primary)}>
        {t("terms_of_service")}
      </a>
      {" · "}
      <a href={localizedPath("privacy", locale)} style={linkStyle(acc.primary)}>
        {t("privacy_policy")}
      </a>
    </div>
  );
}
